import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalCreateClinicService {

    constructor() { }

    private _hideModal: boolean = true;

    public clinicCreated: EventEmitter<string> = new EventEmitter<string>();

    get ocultarModal() {
        return this._hideModal;
    }

    showModal() {
        this._hideModal = false;
    }

    closeModal() {
        this._hideModal = true;
    }
}
